const RATIO_TO_PERCENTAGE = 100;
const DECIMAL_BASE = 10;

export const formatPercentage = (ratio: number, decimals = 2) => {
  const decimalMultiplier = Math.pow(DECIMAL_BASE, decimals);
  return `${Math.round(ratio * RATIO_TO_PERCENTAGE * decimalMultiplier) / decimalMultiplier}%`;
};
